module.exports = __webpack_public_path__ + "img/security_off.1bd47006.svg";